<header
    class="py-3 px-4 md:px-6 shadow-2 flex align-items-center justify-content-between relative lg:static bg-white border-bottom-1 border-gray-200">
    <a routerLink="/" class="flex" aria-label="ESZES home">
        <img [src]="'assets/layout/images/branding/' + configService.config.brand + '/logo-colored-light-150.webp'"
            [srcset]="'assets/layout/images/branding/' + configService.config.brand + '/logo-colored-light-150.webp 1x, assets/layout/images/branding/' + configService.config.brand + '/logo-colored-light-300.webp 2x'"
            alt="ESZES Consultancy &amp; Services" width="150" height="42" />
    </a>
    <button type="button" pRipple class="cursor-pointer block lg:hidden text-900 bg-transparent border-none p-0"
        aria-label="Toggle navigation menu" [attr.aria-expanded]="menuOpen" (click)="menuOpen = !menuOpen">
        <i [class]="(menuOpen ? 'pi pi-times' : 'pi pi-bars') + ' text-4xl'" aria-hidden="true"></i>
    </button>
    <nav aria-label="Main" [ngClass]="{'flex bg-white': menuOpen, 'hidden': !menuOpen}"
        class="align-items-center flex-grow-1 lg:justify-content-end lg:flex absolute lg:static w-full left-0 top-100 px-6 lg:px-0 z-3 shadow-2 lg:shadow-none flex-column lg:flex-row align-items-stretch lg:align-items-center">
        <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row">
            <li *ngFor="let link of links">
                <a pRipple [routerLink]="link.path" routerLinkActive="text-primary-deep" [routerLinkActiveOptions]="{ exact: link.exact }"
                    class="flex px-0 lg:px-4 py-3 text-900 hover:text-primary-deep font-medium transition-colors transition-duration-150 no-underline">
                    <span>{{ link.label }}</span>
                </a>
            </li>
        </ul>
        <div
            class="flex justify-content-between lg:block border-top-1 lg:border-top-none border-gray-200 py-3 lg:py-0 mt-3 lg:mt-0 lg:ml-4">
            <button routerLink="/contact" pButton pRipple label="Contact"
                class="p-button-primary p-button-rounded font-bold"></button>
        </div>
    </nav>
</header>
